module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.119/js/sprocket_orange.svg"